export const RATING_STATUS = {
  NEW: 1,
  CONFIRM: 2,
  REJECTED: 3,
};

export default {
  RATING_STATUS,
};
